import React from "react";
import intl from "react-intl-universal";

import {useAppState} from "@stores/AppStateContext";

import type {CalendarTable} from "../../Lists/components/CalendarTable";
import {TaskReport} from "@stores/taskLists/gql/serverTypes";

import {ImageGalleryPreview} from "../../../components/ImageGalleryPreview";
import {UserCard} from "../../../components/UserCard";
import {InfoBlockPlain} from "../../../components/InfoBlockRow/InfoBlockPlain";

export interface CompleteTaskProps {
    report: TaskReport;
    calendarTable: CalendarTable;
}

export const TaskReportComplete = (
    {
        report,
        calendarTable
    }: CompleteTaskProps) => {
    const appState = useAppState();
    const task = calendarTable.taskDs?.getTaskById(report.taskId);
    const taskName = task?.name;
    const taskListUnit = calendarTable.taskListUnitDS.getTaskListUnitById(report.taskListUnitId);
    const taskListName = Object.values(taskListUnit?.taskLists ?? {}).find(list => list.id === task?.taskListId)?.name ?? intl.get('taskList.ungrouped.short').d('Ungrouped Tasks');

    const usersMap = appState.userState!.usersDS.users

    return (
        <div>
            <div className="title-large-bold TaskReportEdit__ContentBlock__taskName">{taskName}</div>
            <div className="body-medium TaskReportEdit__ContentBlock__tasklListName">{taskListName}</div>
            <div className="TaskReportEdit__ContentBlock">
                <div className="title-medium TaskReportEdit__ContentBlock__header">
                    {intl.get('taskReportEdit.CompletedBy.header').d('Completed by')}
                </div>
                <div className="TaskReportEdit__CompletedByList">
                    {report.completedBy?.map(userId => {
                        const user = usersMap?.get(userId);
                        return (
                            <UserCard user={user} size={24} withBackground={true} isInline={true}/>
                        );
                    })}
                </div>
            </div>
            {report.images && (
                <>
                    <div className="TaskReportEdit__ContentBlock">
                        <div className="title-medium TaskReportEdit__ContentBlock__header">
                            {intl.get('taskReportEdit.required-confirmation.header').d('Required Confirmation')}
                        </div>
                        <ImageGalleryPreview urls={report.images}/>
                    </div>

                </>
            )}
            <InfoBlockPlain
                className="TaskReportEdit__ContentBlock"
                createdBy={report.createdBy}
                createdAt={report.createdAt}
                updatedBy={report.updatedBy}
                updatedAt={report.updatedAt}
            />
        </div>
    );
}
